import React from 'react';
import { Box, Grid } from '@mui/material';
import AchievementsCard from '../AchievementsCard/AchievementsCard';
import { ContentAchievementDetailProps } from './ContentAchievementDetail.props';
import './ContentAchievementDetail.css';
const ContentAchievementDetail: React.FC<ContentAchievementDetailProps> = (props) => {
  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Box className={'content-detail-achievements'}>
          {props.listData.map((badge: any, index: number) => (
            <AchievementsCard
              key={badge.title + index}
              badge={badge}
              selected={index === props.selectedBadgeIndex}
            />
          ))}
        </Box>
      </Grid>
    </Grid>
  );
};
export default ContentAchievementDetail;
